type SseHandler = (data: any) => void;

/**
 * Minimal SSE client over fetch(), so we can send Authorization headers (no token in URL).
 * Expects `data: <json>\n\n` messages.
 */
export async function subscribeSseJson(
  url: string,
  opts: {
    onMessage: SseHandler;
    onError?: (e: unknown) => void;
    signal?: AbortSignal;
  }
): Promise<void> {
  const token = localStorage.getItem('token') || '';
  const headers: Record<string, string> = {};
  if (token) headers.Authorization = `Bearer ${token}`;

  try {
    const resp = await fetch(url, {
      method: 'GET',
      headers,
      signal: opts.signal,
    });
    if (!resp.ok) throw new Error(`SSE failed (${resp.status})`);
    if (!resp.body) throw new Error('SSE response has no body');

    const reader = resp.body.getReader();
    const decoder = new TextDecoder();
    let buf = '';

    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      buf += decoder.decode(value, { stream: true });

      while (true) {
        const sep = buf.indexOf('\n\n');
        if (sep === -1) break;
        const rawEvent = buf.slice(0, sep);
        buf = buf.slice(sep + 2);

        const lines = rawEvent.split('\n');
        for (const line of lines) {
          const l = line.trimEnd();
          if (!l || l.startsWith(':')) continue; // keepalive comment
          if (!l.startsWith('data:')) continue;
          const payload = l.slice('data:'.length).trim();
          if (!payload) continue;
          try {
            opts.onMessage(JSON.parse(payload));
          } catch {
            // ignore malformed events
          }
        }
      }
    }
  } catch (e) {
    if (opts.onError) opts.onError(e);
  }
}

